import {requestBase} from '@/utils/request'

// 规格列表  分页
export function getSpecsPages(data) {
  return requestBase({
    url: '/product/specification/findAllPage',
    method: 'post',
    data
  })
}

// 规格列表
export function getSpecsList() {
  return requestBase({
    url: '/product/specification/findAll',
    method: 'post'
  })
}

// 根据分类id获取规格
export function getSpecByCategoryId(data) {
  return requestBase({
    url: '/product/specification/getSpecByCategoryId',
    method: 'post',
    data
  })
}

// 新增规格
export function addSpec(data) {
  return requestBase({
    url: '/product/specification/addSpec',
    method: 'post',
    data
  })
}

// 修改规格
export function updateSpec(data) {
  return requestBase({
    url: '/product/specification/updateSpec',
    method: 'post',
    data
  })
}

// 删除规格
export function deleteSpecById(data) {
  return requestBase({
    url: `/product/specification/deleteSpecById`,
    method: 'post',
    data
  })
}

// 分类绑定规格
export function categoryBindSpec(data) {
  return requestBase({
    url: `/product/specification/categoryBindSpec`,
    method: 'post',
    data
  })
}

// 获取分类绑定的规格
export function getSpecNameByCategoryId(data) {
  return requestBase({
    url: '/product/specification/getSpecNameByCategoryId',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/product/spec.js